// extracted by mini-css-extract-plugin
export var text = "_2u-0";